module.exports = "\n<div class=\"flash alert {{this.className}} alert-dismissible \" *ngIf=\"active\">\n  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-hidden=\"true\">&times;</button>\n  {{text}}\n</div>\n "


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/flash/flash.component.html
// module id = ../../../../../src/app/flash/flash.component.html
// module chunks = main